import axios from '@utils/axios';

const editGeneCombination = {
  state: {
    geneCombinationId: 0,
    description: '',
    descriptionEn: '',
    phenotype: '',
    phenotypeEn: '',
    defaultTemplate: '',
    defaultTemplateEn: '',
    geneCombination: '',
    gender: 1,
    risk: 1
  },
  mutations: {
    setGeneCombinationId(state, id) {
      state.geneCombinationId = id;
    },
    setDescription(state, description) {
      state.description = description;
    },
    setDescriptionEn(state, descriptionEn) {
      state.descriptionEn = descriptionEn;
    },
    setPhenotype(state, phenotype) {
      state.phenotype = phenotype;
    },
    setPhenotypeEn(state, phenotypeEn) {
      state.phenotypeEn = phenotypeEn;
    },
    setDefaultTemplate(state, template) {
      state.defaultTemplate = template;
    },
    setDefaultTemplateEn(state, templateEn) {
      state.defaultTemplateEn = templateEn;
    },
    setRisk(state, risk) {
      state.risk = risk;
    },
    setGeneCombination(state, comb) {
      state.geneCombination = comb;
    },
    setGender(state, gender) {
      state.gender = gender;
    }
  },
  getters: {
    getDescription(state) {
      return state.description || '';
    },
    getDescriptionEn(state) {
      return state.descriptionEn || '';
    },
    getPhenotype(state) {
      return state.phenotype || '';
    },
    getPhenotypeEn(state) {
      return state.phenotypeEn || '';
    },
    getDefaultTemplate(state) {
      return state.defaultTemplate || '';
    },
    getDefaultTemplateEn(state) {
      return state.defaultTemplateEn || '';
    },
    getGeneCombinationStringArray: (state) => () => state.geneCombination.split(',').map((x) => x.trim()),
  },
  actions: {
    fetchGeneCombination(context) {
      return axios.get('admin/genecombinations/getcombination', { params: {
        GeneCombinationId: context.state.geneCombinationId
      } }).then((res) => {
        context.commit('setDescription', res.data.result.description);
        context.commit('setDescriptionEn', res.data.result.descriptionEn);
        context.commit('setPhenotype', res.data.result.phenotype);
        context.commit('setPhenotypeEn', res.data.result.phenotypeEn);
        context.commit('setDefaultTemplate', res.data.result.defaultTemplate);
        context.commit('setDefaultTemplateEn', res.data.result.defaultTemplateEn);
        context.commit('setRisk', res.data.result.defaultTemplateRisk);
        context.commit('setGender', res.data.result.gender.value);
        context.commit('setGeneCombination', res.data.result.combinationGeneCode.join(','));
      });
    },
    editGeneCombination(context) {
      return axios.patch('admin/genecombinations/edit', {
        GeneCombinationId: Number(context.state.geneCombinationId),
        Description: context.state.description,
        DescriptionEn: context.state.descriptionEn,
        Phenotype: context.state.phenotype,
        PhenotypeEn: context.state.phenotypeEn,
        DefaultTemplate: context.state.defaultTemplate,
        DefaultTemplateEn: context.state.defaultTemplateEn,
        Risk: context.state.risk,
        GeneCombination: context.getters.getGeneCombinationStringArray(),
        Gender: context.state.gender
      });
    },
    resetContext(context) {
      context.commit('setGeneCombinationId', 0);
      context.commit('setPhenotypeEn', '');
      context.commit('setDescription', '');
      context.commit('setDescriptionEn', '');
      context.commit('setDefaultTemplate', '');
      context.commit('setDefaultTemplateEn', '');
      context.commit('setRisk', 1);
      context.commit('setGeneCombination', '');
      context.commit('setGender', 1);
    }
  },
  namespaced: true
};

export default editGeneCombination;
